<template>
    <div class="btn-group">
        <label
            v-tooltip
            v-for="(label, rentalType) in { short: 'Hourly/Daily', long: 'Monthly' }"
            :key="rentalType"
            :title="(!space.rental_types[rentalType]) ? unavailableLabels[rentalType] : false"
            data-trigger="hover"
            data-toggle="tooltip"
        >
            <label
                :disabled="disabled || !space.rental_types[rentalType]"
                :class="{
                    'btn-default': rental !== rentalType,
                    'btn-green': rental === rentalType,
                }"
                class="btn"
            >
                {{ label }}
                <span class="hidden-sm hidden-md-whitelabel">Parking</span>
                <input
                    :value="rentalType"
                    :disabled="disabled || !space.rental_types[rentalType]"
                    v-model="rental"
                    type="radio"
                    name="rental"
                    data-no-style
                >
            </label>
        </label>
    </div>
</template>

<script>
    export default {
        name: 'rental-type-toggle',

        props: {
            value: {
                type: String,
                default() {
                    return '';
                },
            },

            disabled: {
                type: [String, Boolean],
                default() {
                    return false;
                },
            },

            space: {
                type: [Object],
                default() {
                    return {};
                },
            },
        },

        computed: {
            unavailableLabels() {
                return {
                    short: 'This space does not allow short term bookings',
                    long: 'This space does not allow monthly bookings',
                };
            },

            rental: {
                get() {
                    return this.value;
                },

                set(val) {
                    this.$emit('input', val);
                },
            },
        },
    };
</script>
